"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FATAL_SEVERITY = exports.SEVERAL_SEVERITY = exports.ERROR_SEVERITY = exports.WARNING_SEVERITY = exports.INFO_SEVERITY = exports.SEVERITY_WEIGHT = exports.SEVERITY_NAME = exports.DEBUG_PROJECT_KEY = exports.DEBUG_SEVERITY_KEY = void 0;
const bit_utils_request_1 = __importDefault(require("@gcloud-npm/bit.utils.request"));
const bit_utils_types_1 = require("@gcloud-npm/bit.utils.types");
/**
 * Nombre de la variable a buscar en el sessionStorage para establecer el umbral de severidad en
 * el mostrado de mensajes.
 */
exports.DEBUG_SEVERITY_KEY = "SondasMinSeverityLevel";
/**
 * Nombre de la variable a buscar en el sessionStorage para establecer los proyectos
 * sobre los que se quiere activar el modo debug
 */
exports.DEBUG_PROJECT_KEY = "SondasAppsFilter";
(function (SEVERITY_NAME) {
    SEVERITY_NAME["INFO"] = "INFO";
    SEVERITY_NAME["WARNING"] = "WARNING";
    SEVERITY_NAME["ERROR"] = "ERROR";
    SEVERITY_NAME["SEVERAL"] = "SEVERAL";
    SEVERITY_NAME["FATAL"] = "FATAL";
})(exports.SEVERITY_NAME || (exports.SEVERITY_NAME = {}));
(function (SEVERITY_WEIGHT) {
    SEVERITY_WEIGHT[(SEVERITY_WEIGHT["INFO"] = 10)] = "INFO";
    SEVERITY_WEIGHT[(SEVERITY_WEIGHT["WARNING"] = 20)] = "WARNING";
    SEVERITY_WEIGHT[(SEVERITY_WEIGHT["ERROR"] = 30)] = "ERROR";
    SEVERITY_WEIGHT[(SEVERITY_WEIGHT["SEVERAL"] = 40)] = "SEVERAL";
    SEVERITY_WEIGHT[(SEVERITY_WEIGHT["FATAL"] = 50)] = "FATAL";
})(exports.SEVERITY_WEIGHT || (exports.SEVERITY_WEIGHT = {}));
/**
 * Listado de severidades posibles
 */
exports.INFO_SEVERITY = {
    name: exports.SEVERITY_NAME.INFO,
    weight: exports.SEVERITY_WEIGHT.INFO,
};
exports.WARNING_SEVERITY = {
    name: exports.SEVERITY_NAME.WARNING,
    weight: exports.SEVERITY_WEIGHT.WARNING,
};
exports.ERROR_SEVERITY = {
    name: exports.SEVERITY_NAME.ERROR,
    weight: exports.SEVERITY_WEIGHT.ERROR,
};
exports.SEVERAL_SEVERITY = {
    name: exports.SEVERITY_NAME.SEVERAL,
    weight: exports.SEVERITY_WEIGHT.SEVERAL,
};
exports.FATAL_SEVERITY = {
    name: exports.SEVERITY_NAME.FATAL,
    weight: exports.SEVERITY_WEIGHT.FATAL,
};
/**
 * Implementa la clase sonda
 * {@link https://tecnologiadigital-col.atlassian.net/wiki/spaces/TD/pages/1755217921/FrontSonda}
 */
class FrontSonda {
    /**
     * @param {string} processName nombre del servicio/funciona sondar ej: 'CUSTOMIZER.ACTVITY.GETBYNAME'
     * @param {Context} context Contexto
     * @param {string} filePath indica la ruta del fichero donde se genera el mensaje.
     */
    constructor({ processName, context, filePath }) {
        // ******* Public Methods End *******
        // ******* Private Methods start ******
        /**
         * Genera un objeto sonda con la informacion que le pasamos por parametro
         * @param {any} cData Informacion de la sonda
         * @param {string} stackTrace Traza del error
         * @param {Severity} severidad Nivel de serveridad del error
         * @returns {object} Devuelve la sonda construida con toda la informacion de los parametros y contexto
         */
        this._getFinalSondaInfo = (cData, stackTrace, severidad) => {
            let sondaInfo = {};
            let cdUrl = "";
            try {
                cdUrl = window.top.location.href;
            }
            catch (e) {
                cdUrl = window && window.location && window.location.href;
            }
            sondaInfo = {
                cData,
                cdContextInfo: stackTrace || "",
                cdElementType: bit_utils_types_1.JS_ERROR,
                cdEnvironment: (this.context &&
                    this.context.environment &&
                    this.context.environment.name) ||
                    "WEB",
                cdEventName: "",
                cdEventType: "",
                // Usamos el nativo de la pagina
                cdReferer: (document && document.referrer) || "",
                cdSegment: (this.context && this.context.pageSegment) || "no_def",
                cdSource: "FrontSonda",
                cdTimeStamp: new Date().toISOString(),
                cdType: "Error-Handler",
                cdUrl,
                ctzActivityId: "",
                ctzExperienceId: "",
                ctzId: "",
                ctzPageId: "",
                ctzTemplateId: "",
                phCode: "",
                posCode: "",
                status: "",
                uiGAClientId: (this.context && this.context.clientIDs && this.context.clientIDs.ga) ||
                    "",
                wbPageId: (this.context &&
                    this.context.clientIDs &&
                    this.context.clientIDs.pageId) ||
                    "",
                wbSessionId: (this.context &&
                    this.context.clientIDs &&
                    this.context.clientIDs.sessId) ||
                    "",
                webCode: "",
                wsContext: this.origin, // url de js o url html: webpack://src/{nombreJS}
                wsName: this.processName, // linea
                versionJS: this.versionJs,
                criticidad: severidad.name || "",
                userInfo: this.userInfo,
                isWebView: this.context && typeof this.context.isWebView !== undefined
                    ? this.context.isWebView
                    : "No Disponible",
            };
            return sondaInfo;
        };
        /**
         * Comprueba si la información recibida del error es válida
         * @param {error} error error producido a mandar
         * @param {string} info Información extra a aportar a la sonda
         * @return {boolean} Devuelve true si es correcta, false si no
         */
        this._checkValidInput = (message) => {
            let result = true;
            if (message.info) {
                if (typeof message.info !== "string") {
                    result = false;
                }
            }
            if (message.error) {
                if (!(message.error instanceof Error)) {
                    result = false;
                }
            }
            return result;
        };
        /**
         * Envía información de un error a Sondas
         * @param {object} error error producido a mandar
         * @param {string} info Información extra a aportar a la sonda
         * @param {Severity} severidad severidad del error
         * @return {undefined}
         */
        this._sendSondaInfo = ({ error, info, severidad }) => {
            let errorInfo = "";
            let stackTrace = "";
            if (error) {
                if (error.message) {
                    errorInfo = error.message;
                }
                if (error.stack) {
                    stackTrace = error.stack;
                }
                if (error.status) {
                    errorInfo = `WSError with Status: ${error.status}`;
                }
                if (error.statusText) {
                    stackTrace = error.statusText;
                }
            }
            if (info) {
                errorInfo = `${errorInfo}--${info}`;
            }
            if (window && window.nookInfoExchange && !this.context) {
                const timeStamp = new Date().getTime();
                window.nookInfoExchange.registerAsObserver("Context", `frontSonda-${timeStamp}`, (context) => {
                    //Al recibir un mensaje nos desuscribimos para no recibir actualizaciones
                    window.nookInfoExchange.cleanObserver("Context", `frontSonda-${timeStamp}`);
                    this.context = context || null;
                    this.userInfo =
                        context && typeof context.userType !== undefined
                            ? context.userType
                            : "No Disponible";
                    if (context &&
                        context.userType &&
                        context.userType === "Telco" &&
                        context.userIdPartyHash) {
                        this.userInfo += "--" + context.userIdPartyHash;
                    }
                    this._sendInfoToCtzMetricsData(errorInfo, stackTrace, severidad);
                }, false);
            }
            else {
                this._sendInfoToCtzMetricsData(errorInfo, stackTrace, severidad);
            }
            /* we send too dynatrace too */
            try {
                const isFrontApp = typeof window !== "undefined";
                if (isFrontApp && window.dtrum) {
                    window.dtrum.reportCustomError(info, severidad, errorInfo, true);
                }
            }
            catch (err) {
                console.error(err);
            }
        };
        /**
         * Devulve el umbral de severidad establecido en el session para mostrar los mensajes.
         * @return {String} Devuelve el umbral de severidad o el nivel de severidad INFO por defecto.
         */
        this._getLoggerIntervals = () => {
            try {
                const severityName = window.sessionStorage.getItem(exports.DEBUG_SEVERITY_KEY);
                return severityName;
            }
            catch (_a) {
                return exports.INFO_SEVERITY.name;
            }
        };
        /**
         * Devuleve los projectos establecidos en el session con intención de debuggear.
         * @return {Array} Devuelve el array de los projectos o NULL si no encuentra nada.
         */
        this._getLoggerProject = () => {
            try {
                const projects = window.sessionStorage.getItem(exports.DEBUG_PROJECT_KEY);
                return JSON.parse(projects);
            }
            catch (_a) {
                return null;
            }
        };
        /**
         * Obtiene objeto el nivel de severidad a partir del nombre del nivel
         * @param {string}  severityName
         * @return {severity} Devuelve el nivel de severidad o Null si no encuentra nada
         */
        this._getSeverityByName = (severityName) => {
            switch (severityName) {
                case exports.SEVERITY_NAME.WARNING:
                    return exports.WARNING_SEVERITY;
                case exports.SEVERITY_NAME.ERROR:
                    return exports.ERROR_SEVERITY;
                case exports.SEVERITY_NAME.SEVERAL:
                    return exports.SEVERAL_SEVERITY;
                case exports.SEVERITY_NAME.FATAL:
                    return exports.FATAL_SEVERITY;
                case exports.SEVERITY_NAME.INFO:
                default:
                    return exports.INFO_SEVERITY;
            }
        };
        /**
         * Imprime por consola los mensajes de error en base a la configuracion establecida
         * @param {String} info Informacion extra a aportar
         * @param {Severity} severity  indicando el nivel de severidad del mensaje a mostrar
         * @param {Error} error (opcional) Error que se ha producido
         * @return {undefined}
         */
        this._logMessage = (info, severity, error) => {
            const umbral = this._getLoggerIntervals();
            const project = this._getLoggerProject();
            const isDevEnvironment = (this.context &&
                this.context.environment &&
                this.context.environment.name === "dev") ||
                false;
            const data2Show = {
                error: error,
                info: info,
            };
            if ((!umbral && isDevEnvironment) ||
                (umbral && severity.weight >= this._getSeverityByName(umbral).weight)) {
                if (!(project && Array.isArray(project)) ||
                    project.indexOf(this.projectId) !== -1) {
                    switch (severity.name) {
                        case exports.INFO_SEVERITY.name:
                            console.info(data2Show);
                            break;
                        case exports.WARNING_SEVERITY.name:
                            console.warn(data2Show);
                            break;
                        default:
                            console.error(data2Show);
                    }
                }
            }
        };
        this.projectId = PROJECT_ID;
        this.versionJs = VERSION_JS;
        this.processName = processName;
        this.context = context || null;
        this.origin = `${this.projectId}${filePath ? `:${filePath}` : ""}`;
        this.userInfo =
            context && typeof context.userType !== undefined
                ? context.userType
                : "No Disponible";
        if (context &&
            context.userType &&
            context.userType === "Telco" &&
            context.userIdPartyHash) {
            this.userInfo += "--" + context.userIdPartyHash;
        }
    }
    // ******* Public Methods start *******
    /**
     * Envía un mensaje del tipo INFO
     * @param {string} info Información extra a aportar a la sonda
     * @return {undefined}
     */
    infoMessage(info) {
        this._logMessage(info, exports.INFO_SEVERITY);
    }
    /**
     * Envía información de un warning concreto a Sondas
     * Almenos uno de los parámetros debe existir
     * @param {inputMessage} message Objeto con Info o Error con la información a enviar a sondas.
     * @return {undefined}
     */
    warningMessage(message) {
        this._sendLogAndSondaInfo(message, exports.WARNING_SEVERITY);
    }
    /**
     * Envía información de un error concreto a Sondas
     * @param {inputMessage} message Objeto con Info o Error con la información a enviar a sondas.
     * @return {undefined}
     */
    errorMessage(message) {
        this._sendLogAndSondaInfo(message, exports.ERROR_SEVERITY);
    }
    /**
     * Envía información de un error several concreto a Sondas
     * @param {inputMessage} message Objeto con Info o Error con la información a enviar a sondas.
     * @return {undefined}
     */
    severalMessage(message) {
        this._sendLogAndSondaInfo(message, exports.SEVERAL_SEVERITY);
    }
    /**
     * Envía información de un error fatal concreto a Sondas
     * @param {inputMessage} message Objeto con Info o Error con la información a enviar a sondas.
     * @return {undefined}
     */
    fatalMessage(message) {
        this._sendLogAndSondaInfo(message, exports.FATAL_SEVERITY);
    }
    _sendLogAndSondaInfo(message, severityLevel) {
        if (this._checkValidInput(message)) {
            this._logMessage(message.info || null, severityLevel, message.error || null);
            this._sendSondaInfo({
                error: message.error || null,
                info: message.info || null,
                severidad: severityLevel,
            });
        }
        else {
            this._logMessage("Informació no válida", exports.INFO_SEVERITY);
        }
    }
    /**
     * Envía la comunicacion con el servicio de Sondas
     * @param {any} errorInfo (opcional) Información asociada al evento que se está sondando
     * @param {string} stackTrace (opcional) La traza del error
     * @param {Severity} severidad (opcional) severidad de la sonda
     * @return {undefined}
     */
    _sendInfoToCtzMetricsData(errorInfo, stackTrace, severidad) {
        try {
            const endPoint = "https://europe-west1-mov-prod10.cloudfunctions.net/export-customizer-data-metrics";
            const headers = {
                timeout: 6000,
                "Content-Type": "application/json",
            };
            const cData = errorInfo;
            const sondaInfo = this._getFinalSondaInfo(cData, stackTrace, severidad);
            const request = new bit_utils_request_1.default({
                method: bit_utils_types_1.MethodType.POST,
                endpoint: endPoint,
                data: sondaInfo,
                headers,
            });
            request.makeRequest();
        }
        catch (e) {
            console.error("Sonda._sendInfoToCtzMetricsData - ", e);
        }
    }
}
exports.default = FrontSonda;
//# sourceMappingURL=index.js.map